// extracted by mini-css-extract-plugin
module.exports = {"form":"filter-static_form__3ksc_","actions":"filter-static_actions__izTqa","filter-provider":"filter-static_filter-provider___IH6A","sorter":"filter-static_sorter__OX_OJ"};